(() => {
  angular
    .module('app.topmenu')
    .controller('UserMenuController', UserMenu);

  UserMenu.$inject = ['$scope', '$document'];

  function UserMenu($scope, $document) {
    const vm = this;
    vm.open = false;

    const onClickOut = event => {
      if (vm.open && !event.target.closest('.user__menu')) {
        vm.onToggle();
        $scope.$apply();
      }
    }

    vm.onToggle = () => {
      vm.open = !vm.open;

      if (vm.open) {
        $document.on('click', onClickOut);
      } else {
        $document.off('click', onClickOut);
      }
    }
  }
})();
